<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="doctor_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('doctor')">
                            <DoctorsSelectbox v-model="form.doctor_id" :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="nurse_id"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('healthcare_personnel')">
                            <NursesSelectbox v-model="form.nurse_id" :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="medical_examination_date"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('examination_date')">
                            <SelectDate :is-time="true" v-model="form.medical_examination_date" :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="control_date"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('control_date')">
                            <SelectDate v-model="form.control_date"  :is-time="true" :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="control_building"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('control_building')">
                            <campus-selectbox v-model="form.control_building"
                                              :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col sm="12" lg="4">
                    <ValidationProvider
                        name="visit_date"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('visit_date')">
                            <SelectDate v-model="form.visit_date"  :is-time="true" :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                    <b-col sm="12" lg="4">
                        <ValidationProvider
                            name="complaint"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('complaint')">
                                <b-form-textarea v-model="form.complaint" no-resize rows="10" ></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="4">
                        <ValidationProvider
                            name="story"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('story')">
                                <b-form-textarea v-model="form.story" no-resize rows="10" ></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="4">
                        <ValidationProvider
                            name="findings"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('findings')">
                                <b-form-textarea v-model="form.findings" no-resize rows="10" ></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="4">
                        <ValidationProvider
                            name="diagnosis"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('diagnosis')">
                                <b-form-textarea v-model="form.diagnosis" no-resize rows="10" ></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="4">
                        <ValidationProvider
                            name="treatment"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('treatment')">
                                <b-form-textarea v-model="form.treatment" no-resize rows="10" ></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="4">
                        <ValidationProvider
                            name="result"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('result')">
                                <b-form-textarea v-model="form.result" no-resize rows="10" ></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="4">
                        <ValidationProvider
                            name="hospital"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('referred_hospital')">
                                <b-form-textarea v-model="form.hospital" no-resize rows="10" ></b-form-textarea>
                                <b-form-invalid-feedback v-if="errors[0]"
                                                         v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col sm="12" lg="4" class="p-0">
                        <ValidationProvider
                            name="number_of_report_days"
                            rules=""
                            v-slot="{ valid, errors }"
                        >
                            <b-form-group :label="$t('number_of_report_days')">
                                <b-form-input
                                    type="number"
                                    v-model="form.number_of_report_days"
                                ></b-form-input>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

            <div class="col-12 mt-3 d-flex">
                <ProcessingButton
                    :disabled="formLoading"
                    :processing="formLoading"
                    @click="update"
                    :text="$t('save').toLocaleUpperCase('tr-TR')"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import InfirmaryServices from "@/services/InfirmaryServices";
import SelectDate from      "@/components/interactive-fields/SelectDate.vue"
import DoctorsSelectbox from "@/components/interactive-fields/DoctorsSelectbox.vue";
import NursesSelectbox from "@/components/interactive-fields/NursesSelectbox.vue";
import moment from "moment/moment";
import CampusSelectbox from "@/components/interactive-fields/CampusSelectbox.vue";
export default {
    components: {
        CampusSelectbox,
        NursesSelectbox,
        DoctorsSelectbox,
        ProcessingButton,
        ValidationProvider,
        ValidationObserver,
        SelectDate
    },
    props:{
        formId:{
            type:Number,
            required:true
        }
    },

    data() {
        return {
            form:{
                doctor_id:null,
                medical_examination_date:moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                control_date:null,
                control_building:null,
                visit_date:null,
                complaint:null,
                story:null,
                findings:null,
                diagnosis:null,
                treatment:null,
                result:null,
                hospital:null,
                number_of_report_days:null
            },
            formLoading: false,
        }
    },
    methods: {
        async update(){
            const isValid =await this.$refs.formModalValidate.validate()
            if (!isValid) return
            try {
                this.formLoading=true
                this.form.infirmary_user_id=this.formId
                this.form.medical_examination_date = moment(this.form.medical_examination_date).format("YYYY-MM-DD HH:mm:ss")
                await InfirmaryServices.infirmaryRecords(this.form)
                this.$toast.success(this.$t('proccess_success'))
                this.$emit('createExaminationModal',true)
            }catch (err){
                this.showErrors(err,this.$refs.formModalValidate)
            }finally {
                this.formLoading=false
            }
        }

    }
}
</script>
